import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const useOauthData = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "", show: false });
  const [isLoading, setIsLoading] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [disableOnWrong, setDisableOnWrong] = useState(false);
  const [cartoonPhase, setCartoonPhase] = useState("idle");
  const [passwordFeedback, setPasswordFeedback] = useState("idle");
  const [cartoonActivity, setCartoonActivity] = useState("idle");
  const inactivityTimeout = useRef();
  const passwordInputRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    setCartoonActivity("wave");
    const waveTimer = setTimeout(() => {
      setCartoonActivity("idle");
    }, 1800);
    return () => clearTimeout(waveTimer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(true);
    }, 700);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    function setBored() {
      setCartoonActivity("bore");
    }
    clearTimeout(inactivityTimeout.current);
    if (cartoonPhase === "idle" || cartoonPhase === "typing-username") {
      inactivityTimeout.current = setTimeout(() => setBored(), 120000);
    }
    return () => {
      clearTimeout(inactivityTimeout.current);
    };
  }, [username, password, cartoonPhase]);

  useEffect(() => {
    function activity() {
      if (cartoonActivity === "bore" || cartoonActivity === "wave") {
        setCartoonActivity("idle");
      }
    }
    window.addEventListener("keydown", activity);
    window.addEventListener("mousedown", activity);
    window.addEventListener("mousemove", activity);
    return () => {
      window.removeEventListener("keydown", activity);
      window.removeEventListener("mousedown", activity);
      window.removeEventListener("mousemove", activity);
    };
    // eslint-disable-next-line
  }, [cartoonActivity]);

  const ADMIN_USERNAME = "corvell-admin";
  const ADMIN_PASSWORD = "corvell@123";

  useEffect(() => {
    if (document.activeElement && document.activeElement.id === "username") {
      setCartoonPhase("typing-username");
      setCartoonActivity("typing-username");
    } else if (
      document.activeElement &&
      document.activeElement.id === "password"
    ) {
      setCartoonPhase("typing-password");
      setCartoonActivity("hide-eyes");
    } else if (!username && !password) {
      setCartoonPhase("idle");
      setCartoonActivity("idle");
    }
    // eslint-disable-next-line
  }, [username, password]);

  const handleUsernameFocus = () => {
    setCartoonPhase("typing-username");
    setCartoonActivity("typing-username");
  };
  const handlePasswordFocus = () => {
    setCartoonPhase("typing-password");
    setCartoonActivity("hide-eyes");
  };
  const handleBlur = () => {
    setCartoonPhase("idle");
    setCartoonActivity("idle");
  };

  useEffect(() => {
    setPasswordFeedback("idle");
    if (disableOnWrong) setDisableOnWrong(false);
  }, [password, disableOnWrong]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (disableOnWrong) return;
    setIsLoading(true);
    setMessage({ text: "", type: "", show: false });

    if (!username.trim() || !password.trim()) {
      setMessage({
        text: "Please fill in all fields",
        type: "warning",
        show: true,
      });
      setIsLoading(false);
      setPasswordFeedback("idle");
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 800));

    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      setMessage({
        text: "Login successful! Redirecting to dashboard...",
        type: "success",
        show: true,
      });

      setPasswordFeedback("smile");
      setTimeout(() => {
        localStorage.setItem("isAdminAuthenticated", "true");
        navigate("/admin/dashboard");
      }, 1000);
    } else {
      setMessage({
        text: "Invalid username or password. Please try again.",
        type: "error",
        show: true,
      });
      setIsLoading(false);
      setDisableOnWrong(true);
      setPasswordFeedback("angry");
      setTimeout(() => {
        if (passwordInputRef.current) {
          passwordInputRef.current.focus();
        }
      }, 200);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((val) => !val);
  };

  useEffect(() => {
    if (message.show && message.type !== "success") {
      const timer = setTimeout(() => {
        setMessage({ ...message, show: false });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  let isButtonDisabled = isLoading || disableOnWrong;

  return {
    cartoonPhase,
    cartoonActivity,
    username,
    setUsername,
    password,
    setPassword,
    showPassword,
    message,
    setMessage,
    isLoading,
    showWelcome,
    passwordInputRef,
    handleUsernameFocus,
    handlePasswordFocus,
    handleBlur,
    togglePasswordVisibility,
    isButtonDisabled,
    handleSubmit,
    passwordFeedback,
  };
};
